const Contact = ()=>{
    return(
        <div>
           <h1>Hey Everyone my Name is Abhi</h1> 
        </div>
    );

}

export default Contact;